<template>
  <div class="full">
    <BGTemplate class="cg-layer fixedlayer full" :bloom="'bubbles'" @ready="(v) => { engine = v; }">
    </BGTemplate>
    <BlueBubbles v-if="engine && engine.renderer && engine.scene && engine.camera" :camera="engine.camera" :amount="20" :renderer="engine.renderer" :scene="engine.scene"></BlueBubbles>

    <AuthStuff class="cg-layer scroller" @ok="$router.push('/cloud/choose-role')"></AuthStuff>
    <!-- <a class="aboutus" target="_aboutcellgame" href="http://palms.polyu.edu.hk/cell-game">About Cell Game</a> -->

  </div>
</template>

<script>
export default {
  components: {
    Toolbar: () => import(/* webpackChunkName: "cloud" */ '../ui/Toolbar.vue'),
    BlueBubbles: () => import(/* webpackChunkName: "cloud" */ '../game/BlueBubbles.vue'),
    BGTemplate: () => import(/* webpackChunkName: "cloud" */ '../game/BGTemplate.vue'),
    AuthStuff: () => import(/* webpackChunkName: "cloud" */ '../ui/AuthStuff.vue')
  },
  data () {
    return {
      engine: false
    }
  },
  methods: {

  }
}
</script>

<style scoped>
/* */
</style>
